import {styled} from '@mui/system';
import {Box} from '@mui/material';

export const MuiListItemActions = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
}));
